import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, GraduationCapIcon, UsersIcon, MapPinIcon, MusicIcon, AwardIcon, ArrowRightIcon } from 'lucide-react';
import Card from '../ui/Card';
import OptimizedImage from '../ui/OptimizedImage';
import { motion } from 'framer-motion';
const OverviewSections = () => {
  const sections = [{
    title: 'Academic Excellence',
    description: 'Our rigorous curriculum and dedicated teaching staff ensure that students receive a high-quality education that prepares them for future success.',
    icon: <BookOpenIcon className="h-8 w-8 text-blue-700" data-id="element-312" />,
    link: '/academics',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qfRUYQw3ECRPT1ECfn8AxJ/WhatsApp_Image_2025-10-24_at_10.01.23.jpg'
  }, {
    title: 'Admissions',
    description: 'Join our community of learners. Discover the application process, requirements, and scholarship opportunities for prospective students.',
    icon: <GraduationCapIcon className="h-8 w-8 text-blue-700" data-id="element-313" />,
    link: '/admissions',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg'
  }, {
    title: 'Student Life',
    description: 'From sports to arts, clubs to community service, our students enjoy a rich and balanced school experience that develops their talents.',
    icon: <UsersIcon className="h-8 w-8 text-blue-700" data-id="element-314" />,
    link: '/student-life',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg'
  }, {
    title: 'Campus Facilities',
    description: 'Our modern campus provides students with the resources and environment they need to thrive academically, socially, and physically.',
    icon: <MapPinIcon className="h-8 w-8 text-blue-700" data-id="element-315" />,
    link: '/campus',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/de3EQh38fKgVchW9xJS4du/WhatsApp_Image_2025-10-24_at_10.01.26.jpg'
  }, {
    title: 'Arts & Culture',
    description: 'We celebrate creativity and cultural expression through our music, drama, visual arts programs, and cultural events throughout the year.',
    icon: <MusicIcon className="h-8 w-8 text-blue-700" data-id="element-316" />,
    link: '/academics#arts',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg'
  }, {
    title: 'Alumni Success',
    description: 'Our graduates have gone on to achieve remarkable success in various fields, making significant contributions to society locally and globally.',
    icon: <AwardIcon className="h-8 w-8 text-blue-700" data-id="element-317" />,
    link: '/alumni',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg'
  }];
  return <section className="py-12 md:py-16 bg-gray-50" data-id="element-318">
      <div className="container mx-auto px-4" data-id="element-319">
        <motion.div className="text-center mb-10 md:mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-320">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-3" data-id="element-321">
            Discover Isonyin Grammar School
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-322"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-sm md:text-base px-4" data-id="element-323">
            Explore the various aspects of our school that make it a center of
            excellence in education, character development, and talent
            discovery.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-324">
          {sections.map((section, index) => <Card key={index} className="flex flex-col h-full" hover hoverEffect="shadow" hoverLift delay={index * 0.1} data-id="element-325">
              <OptimizedImage src={section.image} alt={section.title} className="rounded-t-lg" aspectRatio="16/9" data-id="element-326" />
              <div className="p-5 md:p-6 flex-grow" data-id="element-327">
                <div className="inline-block p-3 bg-blue-100 rounded-lg mb-4" data-id="element-328">
                  {section.icon}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-blue-900 mb-3" data-id="element-329">
                  {section.title}
                </h3>
                <p className="text-gray-700 mb-4 text-sm md:text-base" data-id="element-330">
                  {section.description}
                </p>
              </div>
              <div className="p-5 md:p-6 pt-0 mt-auto" data-id="element-331">
                <Link to={section.link} className="inline-flex items-center text-blue-700 font-medium hover:text-blue-900 transition-colors text-sm md:text-base" data-id="element-332">
                  Learn More <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-333" />
                </Link>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
};
export default OverviewSections;